import { defineMessages } from 'react-intl';

const messages = defineMessages({
  block02: {
    id: 'block02',
    defaultMessage: 'Block 02',
  },
  default: {
    id: 'default',
    defaultMessage: 'Default',
  },
  URL: {
    id: 'URL',
    defaultMessage: 'URL',
  },
  title: {
    id: 'title',
    defaultMessage: 'Title',
  },
});

export default messages;
